/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import MediumImagePopup from "../../../../components/_utils/MediumImagePopup";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import TimelineStatusBar from "../../../../components/_utils/TimelineCommonComponents/TimelineStatusBar";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import BeneScheduleTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/BeneScheduleTxnDeclinePopup";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import BeneficiaryAccountDetailsPopup from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountDetailsPopup/index.jsx";
import CommonQuickActionButtons from "../../../../components/_utils/CommonQuickActionButtons/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../../components/CommonTimeLineCard";
import Loader from "../../../../components/Loader/Index";
import {
  formatDate,
  formatTimeSlot,
} from "../../../../components/ScheduleTransactions/helpers";
import ScheduleTxnOccurrencesPopup from "../../../../components/ScheduleTransactions/ScheduleTxnOccurrencesPopup";
import BeneficiaryTransactionGridView from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionGridView/index.jsx";
import ScheduleBeneficiaryTransactionViewAllPopup from "../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionViewAllPopup/index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { beneficiaryTransactionsViewAll } from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  clearScheduledBeneficiaryErrors,
  scheduledBeneficiaryAddLabel,
  scheduledBeneficiaryApprove,
  scheduledBeneficiaryDetailsById,
  scheduledBeneficiaryDiscard,
  scheduledBeneficiaryOccurrences,
  scheduledBeneficiaryRemoveLabel,
} from "../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import globalText from "../../../../utils/globalText";
import { globalTextFormat } from "../../../../utils/globalTextFormat.js";
import useCategories from "../../../../utils/useCategories";
import BeneficiaryTransactionViewAllPopup from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionViewAllPopup/index.jsx";

/*                          CONSTANTS & PURE HELPERS                          */

const {
  lengthCheckZero: ZERO,
  lengthCheckOne: ONE,
  lengthCheckTwo: TWO,
  lengthCheckThree: THREE,
} = GlobalConfiguration;

const LABELS_TAB = "Assigned Labels";

const SCHEDULE_NOTE_SHOWN_TIMEOUT = 2500;

const SERVICE = {
  VIEW_OWNER_ACCOUNT: "VAccount",
  VIEW_BENEFICIARY_ACCOUNT: "BVAccount",
  APPROVE_BENEFICIARY_ACCOUNT: "BAAccount",
  APPROVE_SCHEDULE: "BAScheduledTxn",
  VIEW_OCCURRENCES: "BOScheduledTxn",
  ASSIGN_LABEL: "ALabel",
  REMOVE_LABEL: "RLabel",
  APPROVE_INTERNAL_TXN: "AInternalTxn",
};

const TAB = {
  DETAILS: "Details",
  ADDITIONAL_DETAILS: "Additional details",
  TRANSACTION_CREATED: "Transaction created",
  LABELS: LABELS_TAB,
};

const TAB_INDEX_BY_LABEL = {
  [TAB.DETAILS]: ZERO,
  [TAB.ADDITIONAL_DETAILS]: ONE,
  [TAB.TRANSACTION_CREATED]: TWO,
  [TAB.LABELS]: THREE,
};

const getFirstApiError = (response) =>
  response?.payload?.errors?.base?.[0]?.errors?.[0];

const EMPTY_SCHEDULE = {
  id: "",
  name: "",
  amount: "",
  paymentMethod: "",
  category: "",
  deleted: false,
  frequency: "",
  startDate: "",
  endDate: "",
  timeSlot: "",
  occurrences: "",
  createdOn: "",
  createdBy: "",
  rejected: false,
  rejectMessage: "",
  approved: false,
  confidential: false,
  srcAcctNumber: "",
  srcIFSC: "",
  srcId: "",
  beneAcctNumber: "",
  beneIFSC: "",
  beneId: "",
  beneApproved: true,
  beneName: "",
  beneTxnList: [],
};

/** API transaction -> the flat view model the page renders from. */
const mapScheduleData = (data) => ({
  id: data?.txn_id ?? "",
  name: data?.scheduled_name ?? "Not available",
  amount: data?.amount ?? "0",
  paymentMethod: data?.payment_method ?? "",
  category: data?.category_id ?? "",
  deleted: (data?.deleted ?? "N") === "Y",
  frequency: data?.frequency ?? "",
  startDate: data?.transaction_start_date ?? "1970-1-1",
  endDate: data?.transaction_end_date ?? "1970-1-1",
  timeSlot: data?.slot ?? " - ",
  occurrences: data?.occurrences ?? "0",
  createdOn: data?.created_on ?? "",
  createdBy: data?.txn_initiator ?? "",
  rejected: data?.rejected === "Y" || data?.rejected === true,
  rejectMessage: data?.rejection_reason ?? "",
  approved: (data?.approved ?? "N") === "Y",
  confidential: (data?.confidential_transaction ?? "N") === "Y",
  srcAcctNumber: data?.owner_account_bank_acc_no ?? "",
  srcIFSC: data?.owner_account_ifsc_code ?? "",
  srcId: data?.owner_account_id ?? "",
  beneAcctNumber: data?.beneficiary_account_bank_acc_no ?? "",
  beneIFSC: data?.beneficiary_account_ifsc_code ?? "",
  beneId: data?.beneficiary_account_id ?? "",
  beneApproved:
    (data?.beneficiary_account_approval_status ?? "pending") !== "pending",
  beneName: data?.beneficiary_account_name ?? "",
  beneTxnList: data?.beneficiary_transaction_ids ?? [],
});

const normalizeAdditionalDetails = (details = []) =>
  details.map((item) => {
    const hasValue =
      Object.prototype.hasOwnProperty.call(item, "value") &&
      item.value !== null &&
      item.value !== "" &&
      !(Array.isArray(item.value) && item.value.length === ZERO);

    return { ...item, value: hasValue ? item.value : "Not given" };
  });

const toAdditionalDetailEntry = (item) => {
  switch (item.data_type) {
    case "from_year_to_year":
      return {
        heading: item.name,
        content:
          item.value?.from && item.value?.to
            ? `${item.value.from} - ${item.value.to}`
            : "Not given",
        type: "text",
      };
    case "date_range":
      return {
        heading: item.name,
        content:
          item.value?.start_date && item.value?.end_date
            ? `${item.value.start_date} - ${item.value.end_date}`
            : "Not given",
        type: "text",
      };
    case "multi_select_list":
      return {
        heading: item.name,
        content:
          Array.isArray(item.value) && item.value.length
            ? item.value.join(", ")
            : "Not given",
        type: "text",
      };
    case "toggle":
      return {
        heading: item.name,
        content: item.value === true ? "Yes" : "No",
        type: "text",
      };
    default:
      return {
        heading: item.name,
        content: item.value || "Not given",
        type: "text",
      };
  }
};

const toAttachmentEntry = (obj, onImageClick) => {
  if ((obj.data_type || "").toLowerCase() === "hyperlink") {
    const isValid =
      obj?.value &&
      obj.value !== "Not given" &&
      obj.value !== "#" &&
      obj.value !== "";

    return {
      content: isValid ? obj.value : "Not given",
      heading: "URL",
      type: isValid ? "link" : "text",
    };
  }

  const file = obj?.value;
  if (!file || file === "Not given" || typeof file !== "object") {
    return { heading: "File", content: "Not given", type: "text" };
  }

  const mimeType = file?.metadata?.mime_type || "application/octet-stream";
  const fileName = file?.metadata?.filename || "Unknown file";
  const size = file?.metadata?.size ?? "0";
  const fileUrl = file?.file_url;

  if (!fileUrl) {
    return { heading: "File", content: "Not given", type: "text" };
  }

  if (mimeType.startsWith("image/")) {
    return {
      heading: "Image",
      type: "image",
      content: {
        fileName,
        size,
        mimeType,
        url: fileUrl,
        onUrlClick: () => onImageClick({ name: fileName, url: fileUrl }),
      },
    };
  }

  return {
    heading: "File",
    type: "file",
    content: {
      fileName,
      size,
      mimeType,
      url: fileUrl,
      onUrlClick: () => {
        window.open(fileUrl, "_blank")?.focus();
      },
    },
  };
};

/*                                   HOOKS                                    */

/**
 * Labels: popup state, assign / unassign calls and the "labels" list.
 * `onLabelsChanged` switches the page to the Labels tab after a successful
 * action; `onClosedAfterChange` runs when the popup is closed after one.
 */
const useScheduleLabels = ({
  id,
  detailsData,
  onLabelsChanged,
  onClosedAfterChange,
}) => {
  const dispatch = useDispatch();

  const [labels, setLabels] = useState([]);
  const [labelDetails, setLabelDetails] = useState([]);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);

  const labelActionDispatchedRef = useRef(false);

  const labelTxnIds = [id].filter(Boolean);

  useEffect(() => {
    const availableLabels = sessionStorage?.getItem(
      "scheduleBeneficiaryTxnLabels",
    );
    if (availableLabels) {
      setLabels(JSON.parse(availableLabels));
    }
  }, []);

  useEffect(() => {
    setLabelDetails(detailsData?.transaction?.[0]?.labels ?? []);
  }, [detailsData]);

  const runLabelAction = async ({
    action,
    labelsToApply,
    successText,
    failureText,
  }) => {
    setLabelPopupLoading(true);
    const res = await dispatch(
      action({ record_ids: labelTxnIds, labels: labelsToApply }),
    );
    const isSuccess = action?.fulfilled?.match(res);

    if (isSuccess) {
      toast.dismiss();
      CommonToast({
        text: successText,
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      dispatch(scheduledBeneficiaryDetailsById({ id }));
      labelActionDispatchedRef.current = true;
      onLabelsChanged();
    } else {
      toast.dismiss();
      CommonToast({
        text: failureText,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
    setLabelPopupLoading(false);
    return isSuccess;
  };

  const handleAssignLabels = (labelsToAssign) =>
    runLabelAction({
      action: scheduledBeneficiaryAddLabel,
      labelsToApply: labelsToAssign,
      successText: "Labels assigned successfully.",
      failureText: "Failed to assign labels.",
    });

  const handleUnassignLabels = (labelsToUnassign) =>
    runLabelAction({
      action: scheduledBeneficiaryRemoveLabel,
      labelsToApply: labelsToUnassign,
      successText: "Labels unassigned successfully.",
      failureText: "Failed to unassign labels.",
    });

  const handleLabelClose = () => {
    setShowLabelsPopup(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    onClosedAfterChange();
  };

  return {
    labels,
    setLabels,
    labelDetails,
    labelTxnIds,
    showLabelsPopup,
    setShowLabelsPopup,
    labelPopupLoading,
    setLabelPopupLoading,
    handleAssignLabels,
    handleUnassignLabels,
    handleLabelClose,
  };
};

/** Approve button state + handler (reject click / approve click wiring). */
const useScheduleApproval = ({
  id,
  scheduleId,
  isPopup,
  hasModService,
  preApproveAdvice,
  postApproveAdvice,
  markApproved,
  setShowRejectPrompt,
  goFeatureNotAssigned,
}) => {
  const dispatch = useDispatch();

  const [btnClicked, setButtonClicked] = useState({});
  const [scheduleApproveFailed, setScheduleApproveFailed] = useState(false);
  const [scheduleApproveFailedMessage, setScheduleApproveFailedMessage] =
    useState("");

  const setBtnClickedFor = (value) =>
    setButtonClicked((prev) => ({ ...prev, [scheduleId]: value }));

  const handleApprove = async () => {
    setBtnClickedFor("Approve");
    UniversalRefreshToast("Approving schedule.");

    preApproveAdvice?.call();
    const response = await dispatch(
      scheduledBeneficiaryApprove({ id: scheduleId }),
    );

    if (response?.payload?.status ?? false) {
      toast.dismiss();
      markApproved();
      dispatch(scheduledBeneficiaryDetailsById({ id }));
      setTimeout(() => {
        CommonToast({
          text: "Schedule approved successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });
      }, SCHEDULE_NOTE_SHOWN_TIMEOUT);
      if (isPopup) {
        setTimeout(() => {
          setShowRejectPrompt(false);
          window.location.reload();
        }, GlobalConfiguration?.autoCloseTime);
      }
    } else {
      setBtnClickedFor("none");
      setScheduleApproveFailed(true);
      setScheduleApproveFailedMessage(
        getFirstApiError(response) ??
          "Something went wrong while rejecting transaction",
      );
      toast.dismiss();

      CommonToast({
        text: getFirstApiError(response),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
    postApproveAdvice?.call();
  };

  const onApproveClick = () => {
    if (hasModService) {
      handleApprove();
    } else {
      goFeatureNotAssigned("BAScheduledTxn");
    }
  };

  const onRejectClick = () => {
    if (hasModService) {
      setBtnClickedFor("Reject");
      setShowRejectPrompt(true);
    } else {
      goFeatureNotAssigned("BAScheduledTxn");
    }
  };

  return {
    btnClicked,
    setButtonClicked,
    scheduleApproveFailed,
    scheduleApproveFailedMessage,
    onApproveClick,
    onRejectClick,
  };
};

/*                           PRESENTATIONAL PARTS                             */

const ScheduleSummary = ({
  schedule,
  services,
  isPopup,
  hasModService,
  categoryIcon,
  onSourceClick,
  onDestinationClick,
  onOpenConfidential,
  onOpenCategory,
  onOpenHistory,
  onDiscardClick,
}) => {
  const {
    name,
    amount,
    confidential,
    category,
    srcAcctNumber,
    srcIFSC,
    paymentMethod,
    beneAcctNumber,
    beneIFSC,
    deleted,
  } = schedule;

  return (
    <div className="sched-detail-section-inner-1024 w-auto Qsmd:max-w-screen-Qlg Qsmd:w-std-width relative">
      <div className="h-auto flex flex-col Qsmd:flex-row justify-center w-full">
        <div className="w-full Qsmd:w-width-md flex flex-row justify-start items-center px-padding-md Qsmd:pl-padding-sm py-padding-md Qsmd:pr-padding-md">
          <TitleSubtitlePair
            title={name}
            variant="md"
            subtitle="Schedule name"
            titleColor="text-primary"
          />
        </div>

        <hr className="border-primary-bg relative z-z-index-content Qsmd:hidden mx-margin-md Qlg:mx-margin-base"></hr>
        <div className="hidden Qsmd:block border-r border-solid pl-padding-xs border-primary-bg my-margin-md"></div>
        <div className="sched-txn-amount-div w-full py-padding-md Qsmd:py-padding-base flex Qsmd:flex-row justify-between items-stretch text-text-primary Qsmd:w-width-lg">
          <div className="sched-txn-amount flex flex-col items-start pl-padding-md self-center">
            <TitleSubtitlePair
              title={amount ? `INR ${FormatAmount({ price: amount })}` : "N/A"}
              subtitle="Amount"
              titleColor={amount ? "settled" : "text-primary"}
              isBold={true}
            />
          </div>

          <div className="flex flex-row bg-primary-nav-act">
            <div
              className={` ${
                confidential ? " " : "w-auto h-height-full"
              } hidden Qsmd:flex flex-row justify-evenly items-center `}
            >
              {confidential && (
                <TopNavSmallButton
                  btnText={
                    <>
                      {globalText?.CONFIDENTIAL}
                      <br />
                      {globalText?.history}
                    </>
                  }
                  btnType="button"
                  handleFunction={onOpenConfidential}
                  isDisabled={isPopup}
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-nav-act)"
                  disabledBgColor="var(--primary-nav-act)"
                  icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                  hoverOption="white"
                  fullWidthRequired={false}
                />
              )}
            </div>
            {confidential && (
              <div className="border-r border-primary-bg my-margin-md hidden Qsmd:flex"></div>
            )}
            <div className="hidden Qsmd:flex flex-row">
              <TopNavSmallButton
                btnText={category?.category_name}
                btnType="button"
                handleFunction={onOpenCategory}
                isDisabled={isPopup}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--primary-nav-act)"
                disabledBgColor="var(--primary-nav-act)"
                icon={categoryIcon?.url}
                imgColor={categoryIcon?.colour}
                hoverOption="white"
                fullWidthRequired={false}
                isBackgroundRequired={true}
              />
            </div>
          </div>
        </div>
      </div>
      <hr className="border-primary-bg relative z-z-index-content mx-margin-md Qlg:mx-margin-base"></hr>
      <div className="flex flex-col Qsmd:flex-row justify-center w-full">
        <div className="text-text-primary Qsmd:w-width-md flex flex-col items-center justify-between">
          <div className="flex flex-row items-center justify-between w-full px-padding-sm pt-padding-sm Qsmd:p-padding-base Qsmd:pt-padding-md">
            <TitleSubtitlePair
              isDisabled={
                !services?.includes(SERVICE.VIEW_OWNER_ACCOUNT) || isPopup
              }
              alignRight={false}
              title={formatAccountNumber(srcAcctNumber)}
              titleColor={"text-primary"}
              subtitle={"Source account"}
              onClick={onSourceClick}
              info={false}
              showArrow={true}
              hoverOption={"white"}
              isBold={false}
              variant={"md"}
            />

            <CommonBankLogo
              ifsc={srcIFSC}
              variant="big"
              type="pill"
            />
          </div>
          <div className="hidden Qsmd:flex flex-row justify-between items-center w-full Qsmd:pb-padding-md Qsmd:pl-padding-sm">
            <TitleSubtitlePair
              isDisabled={false}
              alignRight={false}
              title={srcIFSC}
              titleColor={"text-primary"}
              subtitle={"IFSC code"}
              info={false}
              showArrow={false}
              isBold={false}
              variant={"md"}
            />

            <TitleSubtitlePair
              isDisabled={false}
              textAlign={"right"}
              title={paymentMethod}
              titleColor={"text-primary"}
              subtitle={"Payment method"}
              info={false}
              showArrow={false}
              isBold={false}
              variant={"md"}
            />
          </div>
        </div>
        <div className="w-icon-md my-auto h-height-base Qsmd:h-stepper-header flex flex-col justify-around items-center mx-auto Qsmd:mx-margin-base Qsmd:ml-margin-xs">
          <div className="hidden Qsmd:block verical-filler border-r border-primary-bg h-height-sm"></div>
          <div className="hidden Qsmd:flex arrow-icon h-icon-md w-icon-md">
            <img
              src={ICONS?.ARROW_RIGHT_BLUE_WHITE}
              className="w-icon-md h-icon-md"
              alt="arrow"
            />
          </div>

          <div className="hidden  Qmd:block verical-filler border-r border-primary-bg h-height-sm"></div>
        </div>
        <div className="flex items-center gap-gap-sm justify-start Qlg:px-padding-md Qsmd:hidden mx-margin-md Qlg:mx-margin-base">
          <div className="w-width-md border-b border-primary-bg"></div>
          <div className="w-icon-md">
            <img
              src={ICONS?.ARROW_DOWN_BLUE_WHITE}
              alt="arrowDownBlueWhite"
            />
          </div>
          <div className="w-width-md border-b border-primary-bg"></div>
        </div>
        <div className="text-text-primary w-full Qsmd:w-width-lg flex flex-col items-start justify-between">
          <div className="flex flex-row w-full justify-between">
            <div className="flex flex-col gap-gap-sm w-full">
              <div className="flex flex-row w-full justify-between px-padding-sm Qsmd:px-padding-base gap-gap-sm items-center pt-padding-sm Qsmd:pt-padding-md">
                <TitleSubtitlePair
                  isDisabled={
                    !services?.includes(SERVICE.VIEW_BENEFICIARY_ACCOUNT) ||
                    isPopup
                  }
                  alignRight={false}
                  title={formatAccountNumber(beneAcctNumber)}
                  titleColor={"text-primary"}
                  subtitle={"Destination account"}
                  onClick={onDestinationClick}
                  info={false}
                  showArrow={true}
                  hoverOption={"white"}
                  isBold={false}
                  variant={"md"}
                />

                <div className="Qsmd:mr-margin-md">
                  <CommonBankLogo
                    ifsc={beneIFSC}
                    variant="big"
                    type="pill"
                  />
                </div>
              </div>
              <hr className="border-primary-bg relative z-z-index-content Qsmd:hidden mx-margin-md Qlg:mx-margin-base"></hr>
              <div className="pl-padding-md pt-padding-sm pb-padding-md Qsmd:hidden">
                <TitleSubtitlePair
                  isDisabled={false}
                  title={paymentMethod}
                  titleColor={"text-primary"}
                  subtitle={"Payment method"}
                  info={false}
                  showArrow={false}
                  isBold={false}
                  variant={"md"}
                />
              </div>
            </div>

            <div className="hidden Qsmd:flex bg-primary-nav-act">
              <TopNavSmallButton
                btnText={
                  <>
                    {globalText?.SCHEDULE} <br /> {globalText?.history}
                  </>
                }
                btnType="button"
                handleFunction={onOpenHistory}
                isDisabled={isPopup}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--primary-nav-act)"
                disabledBgColor="var(--primary-nav-act)"
                icon={ICONS?.TRANSACTION_HISTORY}
                hoverOption="white"
                fullWidthRequired={false}
              />
            </div>
          </div>

          <div className="hidden Qsmd:flex flex-row justify-between items-center gap-gap-xl w-full Qsmd:items-end">
            <div className="pl-padding-sm pt-padding-md Qsmd:pb-padding-md ">
              <TitleSubtitlePair
                isDisabled={false}
                alignRight={false}
                title={beneIFSC}
                titleColor={"text-primary"}
                subtitle={"IFSC code"}
                info={false}
                showArrow={false}
                isBold={false}
                variant={"md"}
              />
            </div>
            <div className="w-icon-md"></div>
            <div className="flex flex-row">
              <div className="border-t border-primary-bg">
                {!deleted && (
                  <div className="hidden Qsmd:flex">
                    <TopNavSmallButton
                      btnText={
                        <>
                          {globalText?.DISCARD} <br />
                          {globalTextFormat(globalText?.SCHEDULE)}
                        </>
                      }
                      btnType="button"
                      handleFunction={onDiscardClick}
                      isDisabled={!hasModService || isPopup}
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      icon={ICONS?.DELETE_WITH_WHITE_CIRCLE}
                      hoverOption="white"
                      fullWidthRequired={false}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DetailsTab = ({
  schedule,
  animationClass,
  hasOccurrenceService,
  isPopup,
  onOccurrencesClick,
}) => (
  <div className={animationClass}>
    <div className="flex flex-col items-center Qsmd:items-start Qsmd:flex-row gap-gap-md pb-padding-md">
      <CommonDetailCard
        cardTitle="Origin details"
        variant="third"
        numCols={ONE}
        entries={[
          {
            content: schedule.createdBy,
            heading: "Created by",
            type: "text",
          },
          {
            content: schedule.createdOn
              ? formatDateViewAll(schedule.createdOn, true, true)
              : "—",
            heading: "On date",
            type: "text",
          },
        ]}
      />

      <CommonDetailCard
        cardTitle="Transfer details"
        variant="third"
        numCols={ONE}
        entries={[
          {
            // NOTE: kept as a one-item array, exactly as before.
            content: [schedule.frequency.split("_").join(" ")].map(
              (s) => s.charAt(ZERO).toUpperCase() + s.slice(ONE),
            ),
            heading: "Frequency",
            type: "text",
          },
          {
            content: schedule.startDate ? formatDate(schedule.startDate) : "—",
            heading: "Start date",
            type: "text",
          },
          {
            content: schedule.endDate ? formatDate(schedule.endDate) : "—",
            heading: "End date",
            type: "text",
          },
          {
            content: schedule.timeSlot
              ? formatTimeSlot(schedule.timeSlot)
              : "—",
            heading: "Time slot",
            type: "text",
          },
          {
            content: schedule.occurrences,
            heading: "Occurrences",
            onClick: onOccurrencesClick,
            isDisabled: !hasOccurrenceService || isPopup,
            type: "text",
          },
        ]}
      />
    </div>
  </div>
);

const AdditionalDetailsTab = ({
  transactions,
  animationClass,
  onImageClick,
}) => {
  const allAdditionalData =
    transactions?.flatMap((txn) =>
      normalizeAdditionalDetails(txn?.additional_data?.data ?? []),
    ) || [];

  const nonAttachmentDetails = allAdditionalData.filter(
    (item) => !["hyperlink", "upload"].includes(item.data_type),
  );
  const attachments = allAdditionalData.filter((item) =>
    ["hyperlink", "upload"].includes(item.data_type),
  );

  return (
    <div className={animationClass}>
      <div className="flex flex-col Qmd:flex-row items-start gap-gap-md pb-padding-md text-text-primary">
        {nonAttachmentDetails.length > ZERO ? (
          <CommonDetailCard
            cardTitle="Additional details"
            variant="third"
            numCols={nonAttachmentDetails.length === ONE ? ONE : TWO}
            entries={nonAttachmentDetails.map(toAdditionalDetailEntry)}
          />
        ) : (
          <CommonDetailCard
            cardTitle="Additional details"
            variant="third"
            numCols={ONE}
            entries={[
              {
                content:
                  "Additional details are not supported for the selected category.",
              },
            ]}
          />
        )}

        {attachments.length > ZERO && (
          <CommonDetailCard
            cardTitle={globalText?.ATTACHMENTS}
            numCols={ONE}
            variant="third"
            entries={attachments.map((obj) =>
              toAttachmentEntry(obj, onImageClick),
            )}
          />
        )}
      </div>
    </div>
  );
};

const TransactionsCreatedTab = ({
  animationClass,
  isLoading,
  filterRef,
  transactions,
}) => (
  <div className={`${animationClass} flex flex-col flex-1`}>
    <div
      className="flex flex-col Qsmd:flex-row gap-y-gap-md gap-x-gap-sm flex-wrap h-full"
      style={{ scrollbarWidth: "none" }}
    >
      {isLoading ? (
        <div className="w-full flex justify-center items-center py-padding-md">
          <Loader />
        </div>
      ) : (
        <BeneficiaryTransactionGridView
          filterRef={filterRef}
          data={transactions}
          typepop={"schedDetailViewAll"}
        />
      )}
    </div>
  </div>
);

const LabelsTab = ({
  animationClass,
  labelDetails,
  iconIsDisabled,
  onEditClick,
  onLabelClick,
}) => (
  <div className={animationClass}>
    <div className="mb-margin-md">
      <CommonContainerCard
        header="Labels"
        iconIsDisabled={iconIsDisabled}
        subheader={globalText?.LABELS_USAGE_NOTE}
        icon={ICONS?.EDIT}
        handleFunction={onEditClick}
      >
        <div className="flex flex-wrap w-full gap-gap-sm overflow-x-auto">
          {Array.isArray(labelDetails) && labelDetails.length ? (
            labelDetails.map((item, idx) => (
              <Chips
                key={idx}
                txtChip={item}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--primary-nav)"
                isTickerRequired={false}
                hoverOptionBtn="white"
                handleFunctionBtn={() => onLabelClick(item)}
              />
            ))
          ) : (
            <p className="text-font-sm text-text-primary">
              No labels assigned.
            </p>
          )}
        </div>
      </CommonContainerCard>
    </div>
  </div>
);

/*                                 COMPONENT                                  */

const ScheduleBeneficiaryTransactionDetails = ({
  isPopup,
  txn_id,
  detailSelected,
  preApproveAdvice,
  postApproveAdvice,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const paramId = useParams().id;
  const scrollContainerRef = useRef(null);
  const categoryMapper = useCategories();
  const id = txn_id ?? paramId;

  const dropdownOptions = PaginationConfiguration.paginationOptions;

  /* ------------------------------- selectors ------------------------------ */
  const services = useSelector((state) => state.refreshToken.services);
  const {
    scheduledBeneficiaryDetailsLoading,
    scheduledBeneficiaryDetailsData,
    scheduledBeneficiaryRejectError,
    scheduledBeneficiaryDiscardLoading,
    scheduledBeneficiaryDiscardError,
  } = useSelector((s) => s.scheduleBeneficiaryTransactions);

  const hasModService = services?.includes(SERVICE.APPROVE_SCHEDULE);
  const hasOccurrenceService = services?.includes(SERVICE.VIEW_OCCURRENCES);

  /* -------------------------------- state -------------------------------- */
  // schedule view model (replaces ~25 individual states, same values)
  const [schedule, setSchedule] = useState(EMPTY_SCHEDULE);
  const [scheduleUpdatedData, setScheduleUpdatedData] = useState(null);
  const [transactionData, setTransactionData] = useState([]);
  const [scheduleOccurrenceDates, setScheduleOccurrenceDates] = useState([]);

  // loading / binding
  const [isLoading, setIsLoading] = useState(true);
  const [doneBinding, setDoneBinding] = useState(false);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [, setIsOpen] = useState(false);

  // popups
  const [selectedImage, setSelectedImage] = useState({});
  const [openImageUrl, setOpenImageUrl] = useState(false);
  const [showPromptModal, setShowPromptModal] = useState(false);
  const [showBeneAccModal, setShowBeneAccModal] = useState(false);
  const [showRejectPrompt, setShowRejectPrompt] = useState(false);
  const [showOccurrencesModal, setShowOccurrencesModal] = useState(false);
  const [showScheduleHistoryPopup, setShowScheduleHistoryPopup] =
    useState(false);
  const [showScheduleConfidentialPopup, setShowScheduleConfidentialPopup] =
    useState(false);
  const [showScheduleCategoryPopup, setShowScheduleCategoryPopup] =
    useState(false);
  const [openLabelSearchPopup, setOpenLabelSearchPopup] = useState(false);
  const [labelName, setLabelName] = useState("");

  // timeline popup
  const [isTimelinePopupOpen, setIsTimelinePopupOpen] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
    Array(scheduledBeneficiaryDetailsData?.[0]?.logs?.length || ZERO).fill(
      false,
    ),
  );

  // tabs
  const [selectedDetail, setSelectedDetail] = useState(
    detailSelected === TAB.ADDITIONAL_DETAILS
      ? "Additional details"
      : "Details",
  );
  const [index, setIndex] = useState(
    TAB_INDEX_BY_LABEL[selectedDetail] ?? ZERO,
  );
  const [prevIndex, setPrevIndex] = useState(ZERO);
  const [animationClass, setAnimationClass] = useState("");

  const {
    id: scheduleId,
    beneTxnList: scheduleBeneTxnList,
    category: scheduleCategory,
  } = schedule;

  /* ------------------------------ small helpers --------------------------- */
  const categoryId =
    scheduledBeneficiaryDetailsData?.transaction?.[0]?.category_id?.category_id;
  const categoryIcon = categoryMapper(categoryId);

  const hasTxnList = scheduleBeneTxnList.length > ZERO;
  const hasTransactionRows =
    transactionData?.payload?.transactions?.length > ZERO;

  const goFeatureNotAssigned = (unavailableService) =>
    navigate("/feature_not_assigned", { state: { unavailableService } });

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${txn_id}`,
    });
  };

  const runIfNotPopup =
    (fn) =>
    (...args) => {
      if (isPopup) {
        actionRestricted();
        return;
      }
      if (typeof fn === "function") return fn(...args);
    };

  /* --------------------------------- hooks -------------------------------- */
  const {
    labels,
    setLabels,
    labelDetails,
    labelTxnIds,
    showLabelsPopup,
    setShowLabelsPopup,
    labelPopupLoading,
    setLabelPopupLoading,
    handleAssignLabels,
    handleUnassignLabels,
    handleLabelClose,
  } = useScheduleLabels({
    id,
    detailsData: scheduledBeneficiaryDetailsData,
    onLabelsChanged: () => {
      setSelectedDetail(LABELS_TAB);
      setIndex(THREE);
    },
    onClosedAfterChange: () => setIndex(THREE),
  });

  const {
    btnClicked,
    setButtonClicked,
    scheduleApproveFailed,
    scheduleApproveFailedMessage,
    onApproveClick,
    onRejectClick,
  } = useScheduleApproval({
    id,
    scheduleId,
    isPopup,
    hasModService,
    preApproveAdvice,
    postApproveAdvice,
    markApproved: () => setSchedule((prev) => ({ ...prev, approved: true })),
    setShowRejectPrompt,
    goFeatureNotAssigned,
  });

  /* ------------------------------- handlers ------------------------------- */
  const handleBeneAccModalClose = () => {
    setShowBeneAccModal(false);
    dispatch(scheduledBeneficiaryDetailsById({ id }));
  };

  const handleScheduleDiscard = async () => {
    UniversalRefreshToast("Discarding schedule.");
    const result = await dispatch(
      scheduledBeneficiaryDiscard({ id: scheduleId }),
    );
    if (result?.payload?.status ?? false) {
      toast.dismiss();
      setTimeout(() => {
        CommonToast({
          text: "Schedule discarded successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });
      }, SCHEDULE_NOTE_SHOWN_TIMEOUT);
      setShowPromptModal(false);
      setSchedule((prev) => ({ ...prev, deleted: true }));
    } else {
      CommonToast({
        text: scheduledBeneficiaryDiscardError,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
      setShowPromptModal(false);
    }
    dispatch(scheduledBeneficiaryDetailsById({ id }));
  };

  const handleSelect = (value) => {
    setCurrentPage(1);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => setCurrentPage(page);

  const handleShowOccurrences = async () => {
    const response = await dispatch(
      scheduledBeneficiaryOccurrences({
        paramsData: {
          frequency: schedule.frequency,
          transaction_start_date: schedule.startDate,
          transaction_end_date: schedule.endDate,
        },
        services,
        navigate,
      }),
    );
    setScheduleOccurrenceDates(response?.payload?.dates ?? []);
    setShowOccurrencesModal(true);
  };

  const handleOccurrencesClick = () => {
    if (isPopup) {
      actionRestricted();
    } else if (hasOccurrenceService) {
      handleShowOccurrences();
    } else {
      goFeatureNotAssigned("BOScheduledTxn");
    }
  };

  // NOTE: service check comes before the popup check here (kept as before).
  const handleSourceAccountClick = () => {
    if (!services?.includes(SERVICE.VIEW_OWNER_ACCOUNT)) {
      goFeatureNotAssigned("VAccount");
    } else if (isPopup) {
      actionRestricted();
    } else {
      navigate(
        `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${schedule.srcId}`,
      );
    }
  };

  const handleDestinationAccountClick = () => {
    if (!services?.includes(SERVICE.VIEW_BENEFICIARY_ACCOUNT)) {
      goFeatureNotAssigned("BVAccount");
    } else if (isPopup) {
      actionRestricted();
    } else {
      navigate(
        `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${schedule.beneId}`,
      );
    }
  };

  // The desktop and mobile discard buttons intentionally keep the service name
  // they used before (the mobile one says "IAScheduledTxn").
  const handleDiscardClick = (unavailableService) =>
    runIfNotPopup(() => {
      if (hasModService) {
        setShowPromptModal(true);
      } else {
        goFeatureNotAssigned(unavailableService);
      }
    });

  const handleApprovalPendingClick = () =>
    services?.includes(SERVICE.APPROVE_BENEFICIARY_ACCOUNT)
      ? setShowBeneAccModal(true)
      : goFeatureNotAssigned("BAAccount");

  const handleEditLabelsClick = (e) => {
    e.stopPropagation();
    if (
      !(
        services?.includes(SERVICE.ASSIGN_LABEL) &&
        services?.includes(SERVICE.REMOVE_LABEL)
      )
    ) {
      goFeatureNotAssigned("ALabel,RLabel");
      return;
    }
    if (isPopup) {
      actionRestricted();
      return;
    }
    setShowLabelsPopup(true);
  };

  const handleLabelChipClick = (item) => {
    if (isPopup) {
      actionRestricted();
      return;
    }
    setLabelName(item);
    setOpenLabelSearchPopup(true);
  };

  const handleTimelinePopup = () => {
    if (isPopup) {
      actionRestricted();
    } else {
      setIsTimelinePopupOpen(true);
      setShowApprovalTimeline(true);
    }
  };

  const closeTimelinePopup = () => {
    setOpenApprovalTimeline([]);
    setIsTimelinePopupOpen(false);
    setShowApprovalTimeline(false);
  };

  const handleApprovalTimeline = (timelineIndex) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[timelineIndex] = !newOpenDivs[timelineIndex];
      return newOpenDivs;
    });
  };

  const handleImageClick = (image) => {
    setOpenImageUrl(true);
    setSelectedImage(image);
  };

  const selectTab = (label, tabIndex) => () => {
    setSelectedDetail(label);
    setIndex(tabIndex);
  };

  /* -------------------------------- effects ------------------------------- */
  // in popup mode always start on the requested tab
  useEffect(() => {
    if (!isPopup) return;

    const initialDetail =
      detailSelected === TAB.ADDITIONAL_DETAILS
        ? "Additional details"
        : "Details";

    setSelectedDetail(initialDetail);
    setIndex(initialDetail === "Additional details" ? ONE : ZERO);
  }, [isPopup, detailSelected]);

  // slide direction for tab animation
  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index, prevIndex]);

  // fall back to "Details" when the "Transaction created" tab disappears
  useEffect(() => {
    if (!doneBinding || scheduledBeneficiaryDetailsLoading) return;

    if (selectedDetail === TAB.TRANSACTION_CREATED && !hasTxnList) {
      setSelectedDetail("Details");
      setIndex(ZERO);
      setCurrentPage(1);
    }
  }, [
    hasTxnList,
    doneBinding,
    scheduledBeneficiaryDetailsLoading,
    selectedDetail,
  ]);

  // fetch details
  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(disableSwitcher());
        const response = await dispatch(
          scheduledBeneficiaryDetailsById({ id }),
        );
        if (
          response?.error?.status === 404 ||
          response?.payload?.status === 404 ||
          response?.payload?.statusCode === 404
        ) {
          navigate("*");
          return;
        }
      } catch (error) {
        console.error("Failed to load schedule transaction details", error);
      }
    };
    fetchData();
  }, [dispatch, paramId, txn_id, navigate]);

  // transactions created by this schedule
  useEffect(() => {
    const handleFetch = async () => {
      setIsLoading(true);
      const data = await dispatch(
        beneficiaryTransactionsViewAll({
          page_item_count: pageSize,
          page_no: currentPage,
          txn_id: scheduleBeneTxnList || [],
        }),
      );
      setIsLoading(false);
      setTransactionData(data);
    };
    if (scheduleBeneTxnList?.length) {
      handleFetch();
    }
  }, [scheduleBeneTxnList, currentPage, pageSize]);

  // lock body scroll while a modal is open
  useEffect(() => {
    document.body.style.overflow =
      showOccurrencesModal ||
      showPromptModal ||
      showRejectPrompt ||
      showBeneAccModal
        ? "hidden"
        : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [
    showOccurrencesModal,
    showPromptModal,
    showRejectPrompt,
    showBeneAccModal,
  ]);

  // bind fetched details into the view model
  useEffect(() => {
    if (!scheduledBeneficiaryDetailsData) {
      setDoneBinding(true);
      return;
    }

    dispatch(clearScheduledBeneficiaryErrors());

    const uiState = addLifeCycleStatus({
      lifecycle_status:
        scheduledBeneficiaryDetailsData?.transaction?.[0]?.lifecycle_status,
      services,
      cardType: "single",
    });

    const newData = {
      ...scheduledBeneficiaryDetailsData,
      transaction: scheduledBeneficiaryDetailsData?.transaction?.map(
        (account) => ({
          ...account,
          loading: false,
          error: false,
          message: "",
          last_updated_user_id_check: false,
          statusName: uiState.statusName,
          statusColor: uiState.statusColor,
          distributionStatusName: uiState.distributionStatusName,
          distributionStatusColor: uiState.distributionStatusColor,
          barColor: uiState.barColor,
          barValue: uiState.barValue,
        }),
      ),
    };

    const data = newData?.transaction?.[0];
    setSchedule(data ? mapScheduleData(data) : (prev) => ({ ...prev, id: "" }));

    setScheduleUpdatedData((prev) =>
      JSON.stringify(prev) === JSON.stringify(newData) ? prev : newData,
    );

    setDoneBinding(true);
  }, [scheduledBeneficiaryDetailsData]);

  /* ----------------------------- shared payloads -------------------------- */
  const accountHistoryPayload = {
    id: schedule.beneId,
    number: schedule.beneAcctNumber,
    name: schedule.beneName,
    schedule_acc_name: schedule.beneName,
  };

  const statusBarCommonProps = {
    overrideAutoLoader: true,
    whichBtnClicked: btnClicked?.[scheduleId] || "none",
    failedToTakeaction:
      !!scheduleApproveFailed || scheduledBeneficiaryRejectError,
    failedToTakeIcon: true,
    failedToTakeactionReason:
      scheduleApproveFailedMessage ||
      scheduledBeneficiaryRejectError?.errors?.base?.[0]?.errors?.[0],
    rejected: schedule.rejected && !schedule.deleted,
    rejectedReason: schedule.rejectMessage,
    accountApprovalPending:
      !schedule.approved && !schedule.deleted && !schedule.beneApproved,
    handleApprovalPendingBtn: handleApprovalPendingClick,
    // NOTE: uses "AInternalTxn" exactly as before.
    isApprovalPendingDisabled: !services?.includes(
      SERVICE.APPROVE_INTERNAL_TXN,
    ),
    pending: !schedule.approved && !schedule.deleted && schedule.beneApproved,
    accountApprovalPendingSubHeader: services?.includes(
      SERVICE.APPROVE_SCHEDULE,
    )
      ? "Account is not approved, approve account before approving transaction."
      : "To approve the account, please contact the authorized person.",
    rejectBtnText: (
      <>
        Reject <br /> Schedule
      </>
    ),
    approveBtnText: (
      <>
        Approve <br /> Schedule
      </>
    ),
  };

  const labelsEditDisabled =
    !(
      services?.includes(SERVICE.ASSIGN_LABEL) &&
      services?.includes(SERVICE.REMOVE_LABEL)
    ) || isPopup;

  /* --------------------------------- render ------------------------------- */
  return (
    <>
      <>{RestrictedActionPopup}</>
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleLabelClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTxnIds}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={(scheduledBeneficiaryDetailsData?.transaction || [])
              ?.filter((t) => labelTxnIds.includes(t.txn_id))
              ?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleLabelClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabels}
            handleUnassignLabels={handleUnassignLabels}
          />
        </div>
      )}

      {openLabelSearchPopup && (
        <BeneficiaryTransactionViewAllPopup
          isOpen={openLabelSearchPopup}
          onClose={() => setOpenLabelSearchPopup(false)}
          headerTitle={`Transactions with the label - ${labelName}`}
          contentProps={{
            openTransHistory: openLabelSearchPopup,
            onClose: () => setOpenLabelSearchPopup(false),
            typepop: "txnHistorypopup",
            popup: "Label",
            propType: "txnLabelDetails",
            txnLabel: labelName,
            bene_account_name: "",
            bene_account_id: "",
            bene_account_confidential: null,
            category: "",
          }}
        />
      )}

      {showPromptModal && (
        <div className="fixed z-z-index-max flex items-center justify-center  top-left-base left-left-base w-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle="Confirm discarding this schedule?"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="No future transactions will be generated from this schedule."
            btnOneText="Cancel"
            btnOneHandleFunction={() => setShowPromptModal(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Discard"
            btnTwoHandleFunction={handleScheduleDiscard}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            btnTwoLoading={scheduledBeneficiaryDiscardLoading ?? false}
          />
        </div>
      )}
      {showOccurrencesModal && (
        <ScheduleTxnOccurrencesPopup
          closeCallback={() => setShowOccurrencesModal(false)}
          occurrences={scheduleOccurrenceDates}
        />
      )}
      {showRejectPrompt && (
        <BeneScheduleTxnDeclinePopup
          allTxnData={scheduleUpdatedData?.transaction}
          handleClose={() => {
            setShowRejectPrompt(false);
            setButtonClicked((prev) => ({
              ...prev,
              [scheduleId]: "none",
            }));
          }}
          txnId={scheduleId}
          updateAllTxn={(updatedData) => {
            setScheduleUpdatedData((prev) => ({
              ...prev,
              transaction: updatedData,
            }));
          }}
          onRejectSuccess={() => {
            setShowRejectPrompt(false);
            window.location.reload();
          }}
          type="beneScheduleTxnDetail"
          toastType="singleSchedule"
        />
      )}

      {openImageUrl && (
        <div className="fixed top-top-base left-left-base w-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <MediumImagePopup
            image={selectedImage}
            closehandleFunction={() => setOpenImageUrl(false)}
          />
        </div>
      )}

      {isTimelinePopupOpen && (
        <LargePopupRedirect
          headerTitle="Schedule timeline"
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headertextSize="font-md"
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={closeTimelinePopup}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          handleFunction={() => {}}
          enabledBgColor={"var(--positive-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
          isLoading={false}
          buttonRef={null}
          inActiveVariantNeeded={false}
          isLoaderNeeded={false}
          isscrollRequired={true}
        >
          <TimelinePopupContent
            logsData={scheduleUpdatedData?.transaction}
            handleApprovalClick={handleTimelinePopup}
            showDistributionRightIcon={false}
            showApprovalLeftIcon={false}
            showApprovalTimeline={showApprovalTimeline}
            openApprovalTimeline={openApprovalTimeline}
            handleApprovalTimeline={handleApprovalTimeline}
            setOpenApprovalTimeline={setOpenApprovalTimeline}
            cardType={"single"}
            popUpMode={true}
          />
        </LargePopupRedirect>
      )}

      {showBeneAccModal && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-light-opacity"
          onClick={handleBeneAccModalClose}
        >
          <BeneficiaryAccountDetailsPopup
            closeBeneAccountDetailModal={handleBeneAccModalClose}
            bene_account_id={schedule.beneId}
            type={"bene_account_detail_modal"}
          />
        </div>
      )}

      {showScheduleHistoryPopup && (
        <ScheduleBeneficiaryTransactionViewAllPopup
          headerTitle={"Schedule history"}
          headerSubtitle={
            "All scheduled transaction related to beneficiary are listed below."
          }
          onClose={() => setShowScheduleHistoryPopup(false)}
          contentProps={{
            type: "history",
            payload: accountHistoryPayload,
            isPopup: true,
            closeCallback: () => setShowScheduleHistoryPopup(false),
          }}
        />
      )}

      {showScheduleCategoryPopup && (
        <ScheduleBeneficiaryTransactionViewAllPopup
          headerTitle={"Category history"}
          headerSubtitle={
            "All scheduled transaction related to beneficiary are listed below."
          }
          onClose={() => setShowScheduleCategoryPopup(false)}
          contentProps={{
            type: "category",
            payload: scheduleCategory,
            isPopup: true,
            closeCallback: () => setShowScheduleCategoryPopup(false),
          }}
        />
      )}

      {showScheduleConfidentialPopup && (
        <ScheduleBeneficiaryTransactionViewAllPopup
          headerTitle={"Confidential history"}
          headerSubtitle={
            "All scheduled transaction related to beneficiary are listed below."
          }
          onClose={() => setShowScheduleConfidentialPopup(false)}
          contentProps={{
            type: "confidential",
            payload: accountHistoryPayload,
            isPopup: true,
            closeCallback: () => setShowScheduleConfidentialPopup(false),
          }}
        />
      )}

      <div
        className={`flex flex-col overflow-hidden ${isPopup ? "h-full" : "h-screen"}`}
      >
        {!doneBinding || scheduledBeneficiaryDetailsLoading ? (
          <div className="w-full h-full-height flex flex-row justify-center items-center">
            <Loader />
          </div>
        ) : (
          <>
            <div
              className={`bg-primary-nav ${
                isPopup
                  ? "hidden"
                  : "h-loader-lg Qsmd:h-navbar-breadcrumb-height flex Qsmd:flex-shrink-0"
              }`}
            ></div>
            <div
              ref={scrollContainerRef}
              className="flex flex-col flex-1 overflow-y-auto overflow-x-hidden scroll-py-top_md"
            >
              {hasTransactionRows &&
                selectedDetail === TAB.TRANSACTION_CREATED && (
                  <div
                    style={{
                      zIndex: "var(--z-index-fixed-ui)",
                      width: "var(--width-full)",
                      bottom: "var(--bottom-base)",
                      borderRadius: "var(--rounded-none)",
                    }}
                    className="bg-primary-nav h-pagination-height fixed w-full"
                  >
                    <PaginationComponent
                      handleSelect={handleSelect}
                      selectedValue={selectedValue}
                      data={transactionData?.payload}
                      pageSize={pageSize}
                      dropdownOptions={dropdownOptions}
                      handlePagination={handlePagination}
                      currentPage={currentPage}
                      setIsOpen={setIsOpen}
                    />
                  </div>
                )}

              {!isPopup && (
                <div className="sched-mobile-nav-bar fixed top-top-base left-left-base mt-margin-base w-full z-z-index-header bg-primary-nav shadow-box-shadow-bottom Qsmd:hidden block">
                  <TopNavComponent
                    topNavHeader={globalText?.BENEFICIARY_TRANSACTIONS}
                    topNavSubText={globalTextFormat(
                      globalText?.SCHEDULE_DETAILS,
                      [0],
                    )}
                    isFormattingNotRequired={true}
                  />
                </div>
              )}
              <div className="flex flex-col flex-1 bg-primary-nav">
                <div>
                  <div className="h-auto bg-primary-nav Qsmd:flex Qsmd:flex-row justify-center relative">
                    <ScheduleSummary
                      schedule={schedule}
                      services={services}
                      isPopup={isPopup}
                      hasModService={hasModService}
                      categoryIcon={categoryIcon}
                      onSourceClick={handleSourceAccountClick}
                      onDestinationClick={handleDestinationAccountClick}
                      onOpenConfidential={runIfNotPopup(() =>
                        setShowScheduleConfidentialPopup(true),
                      )}
                      onOpenCategory={runIfNotPopup(() =>
                        setShowScheduleCategoryPopup(true),
                      )}
                      onOpenHistory={runIfNotPopup(() =>
                        setShowScheduleHistoryPopup(true),
                      )}
                      onDiscardClick={handleDiscardClick("BAScheduledTxn")}
                    />
                    <div className="block Qsmd:hidden">
                      {!(schedule.approved || schedule.deleted) && (
                        <TimelineStatusBar
                          {...statusBarCommonProps}
                          showMobile={true}
                          rejectMobClick={onRejectClick}
                          isRejectMobDisable={!hasModService}
                          approveMobClick={onApproveClick}
                          isApproveMobDisable={!hasModService}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-center bg-primary-bg Qsmd:flex-1">
                  <div className="max-w-screen-Qlg w-width-full flex flex-col mt-margin-md">
                    <div className="block Qsmd:hidden">
                      <CommonQuickActionButtons
                        title="Quick Actions"
                        actions={[
                          {
                            key: "schedule-category",
                            btnText: scheduleCategory?.category_name,
                            btnType: "button",
                            handleFunction: runIfNotPopup(() =>
                              setShowScheduleCategoryPopup(true),
                            ),
                            isDisabled: isPopup,
                            icon: categoryIcon?.url,
                            imgColor: categoryIcon?.colour,
                            isBackgroundRequired: true,
                          },
                          {
                            key: "schedule-history",
                            btnText: (
                              <>
                                {globalText?.SCHEDULE}
                                <br />
                                {globalText?.history}
                              </>
                            ),
                            btnType: "button",
                            handleFunction: runIfNotPopup(() =>
                              setShowScheduleHistoryPopup(true),
                            ),
                            isDisabled: isPopup,
                            icon: ICONS?.TRANSACTION_HISTORY,
                          },
                          {
                            key: "confidential-history",
                            hidden: !schedule.confidential,
                            btnText: (
                              <>
                                {globalText?.CONFIDENTIAL}
                                <br />
                                {globalText?.history}
                              </>
                            ),
                            btnType: "button",
                            handleFunction: runIfNotPopup(() =>
                              setShowScheduleConfidentialPopup(true),
                            ),
                            isDisabled: isPopup,
                            icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                          },
                          {
                            key: "discard-schedule",
                            hidden: schedule.deleted,
                            btnText: (
                              <>
                                {globalText?.DISCARD}
                                <br />
                                {globalTextFormat(globalText?.SCHEDULE)}
                              </>
                            ),
                            btnType: "button",
                            handleFunction:
                              handleDiscardClick("IAScheduledTxn"),
                            isDisabled: isPopup || !hasModService,
                            icon: ICONS?.DELETE_WITH_WHITE_CIRCLE,
                          },
                        ]}
                      />
                    </div>
                    <div
                      className={`Qlg:mx-margin-base ml-margin-md mr-margin-md mt-margin-md Qlg:mr-margin-base Qsmd:mx-margin-md flex flex-row items-end ${
                        !(
                          schedule.approved ||
                          schedule.rejected ||
                          schedule.deleted
                        )
                          ? "Qsmd:justify-center justify-start"
                          : "justify-start"
                      } `}
                    >
                      <div
                        className={`relative w-timeline-status-card-width h-height-full bg-primary-card rounded-l-border-radius-md rounded-tr-border-radius-md Qsmd:w-width-sm ${
                          schedule.approved || schedule.deleted
                            ? "rounded-br-border-radius-md"
                            : "rounded-br-border-radius-md Qsmd:rounded-br-none"
                        } `}
                      >
                        <div className="w-full h-height-full text-text-primary bg-primary-nav relative rounded-border-radius-md">
                          <div className="text-font-xs py-padding-sm px-padding-md font-semibold">
                            Schedule timeline
                          </div>
                          <hr className="relative left-left-base border-primary-bg border-t-border mx-margin-md" />

                          <div>
                            <CommonTimeLineCard
                              logsData={scheduleUpdatedData?.transaction}
                              handleApprovalClick={handleTimelinePopup}
                              showApprovalTimeline={true}
                              showDistributionTimeline={false}
                              showDistributionRightIcon={true}
                              showApprovalLeftIcon={true}
                              showApprovalDuration={true}
                              cardType={"single"}
                              isDisabled={isPopup ? true : false}
                              leftCardTitle="Stage - Approval"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="hidden Qsmd:flex flex-col flex-grow w-width-md">
                        {scheduleUpdatedData?.transaction?.map((txn) => (
                          <TimelineStatusBar
                            key={txn.txn_id}
                            {...statusBarCommonProps}
                            hasDistributionData={false}
                            showMobile={false}
                            rejectClick={onRejectClick}
                            isRejectDisable={!hasModService}
                            approveClick={onApproveClick}
                            isApproveDisable={!hasModService}
                          />
                        ))}
                      </div>
                    </div>
                    <div
                      className={`w-full max-w-screen-Qlg bg-primary-bg flex flex-col flex-1 ${index === THREE ? "" : "px-padding-md lg:px-padding-base"}`}
                      style={{ scrollbarWidth: "none" }}
                    >
                      <div
                        className={`${index === TWO ? "py-padding-md !pb-padding-base" : "py-padding-md"} flex overflow-x-auto`}
                        style={{ scrollbarWidth: "none" }}
                      >
                        <div
                          className={`flex gap-gap-sm bg-primary-card w-auto rounded-border-radius-md ${index === THREE ? "mx-margin-md lg:mx-margin-base" : ""}`}
                        >
                          <SwitcherTabs
                            initialActiveTab={
                              selectedDetail in TAB_INDEX_BY_LABEL
                                ? selectedDetail
                                : "Details"
                            }
                            tabs={[
                              {
                                label: "Details",
                                key: "Details",
                                handler: selectTab("Details", ZERO),
                              },
                              {
                                label: "Additional details",
                                key: "Additional details",
                                handler: selectTab("Additional details", ONE),
                              },
                              ...(hasTxnList
                                ? [
                                    {
                                      label: "Transaction created",
                                      key: "Transaction created",
                                      handler: selectTab(
                                        "Transaction created",
                                        TWO,
                                      ),
                                    },
                                  ]
                                : []),
                              {
                                label: "Labels",
                                key: LABELS_TAB,
                                handler: selectTab(LABELS_TAB, THREE),
                              },
                            ]}
                            setIndex={setIndex}
                          />
                        </div>
                      </div>
                      <div className="relative flex flex-col flex-1">
                        {index === ZERO && (
                          <DetailsTab
                            schedule={schedule}
                            animationClass={animationClass}
                            hasOccurrenceService={hasOccurrenceService}
                            isPopup={isPopup}
                            onOccurrencesClick={handleOccurrencesClick}
                          />
                        )}

                        {index === ONE && (
                          <AdditionalDetailsTab
                            transactions={
                              scheduledBeneficiaryDetailsData?.transaction
                            }
                            animationClass={animationClass}
                            onImageClick={handleImageClick}
                          />
                        )}

                        {index === TWO && (
                          <TransactionsCreatedTab
                            animationClass={animationClass}
                            isLoading={isLoading}
                            filterRef={scrollContainerRef}
                            transactions={
                              transactionData?.payload?.transactions
                            }
                          />
                        )}

                        {index === THREE && (
                          <LabelsTab
                            animationClass={animationClass}
                            labelDetails={labelDetails}
                            iconIsDisabled={labelsEditDisabled}
                            onEditClick={handleEditLabelsClick}
                            onLabelClick={handleLabelChipClick}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {index === TWO && !isLoading && (
              <div className="h-pagination-height flex-shrink-0"></div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ScheduleBeneficiaryTransactionDetails;
